"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _params = require("hub-http/helpers/params");

var API_BASE = 'extensions/sales-objects/v1';

var buildFetchUrl = function buildFetchUrl(_ref) {
  var objectTypeId = _ref.objectTypeId,
      associatedObjectId = _ref.associatedObjectId,
      associatedObjectType = _ref.associatedObjectType;
  var params = {
    objectTypeId: objectTypeId,
    associatedObjectId: associatedObjectId,
    associatedObjectType: associatedObjectType
  };
  return API_BASE + "/objects?" + (0, _params.stringify)(params);
};

var _default = {
  fetch: function fetch(_ref2) {
    var objectTypeId = _ref2.objectTypeId,
        associatedObjectId = _ref2.associatedObjectId,
        associatedObjectType = _ref2.associatedObjectType;
    return ImmutableAPI.get(buildFetchUrl({
      objectTypeId: objectTypeId,
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType
    }));
  },
  doActionHook: function doActionHook(action) {
    return ImmutableAPI.post(API_BASE + "/actions", action);
  }
};
exports.default = _default;
module.exports = exports.default;